import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_REQUEST__generation_create } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_create';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../STATE__generation';

export const REMOTE__generation_create = createAsyncThunkSafe<string | DTO_RESPONSE__error, DTO_REQUEST__generation_create>(
  ENUM__network_event_client_to_server.GENERATION_CREATE,
  async (request): Promise<string> => {
    return await send_to_server(ENUM__network_event_client_to_server.GENERATION_CREATE, request);
  },
);

export function INIT_REMOTE__generation_create(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__generation_create.pending, (state, action) => {})
    .addCase(REMOTE__generation_create.rejected, (state, action) => {})
    .addCase(REMOTE__generation_create.fulfilled, (state, action: PayloadAction<string | DTO_RESPONSE__error>) => {});
}
